// import React from "react";
// // import { useState } from "react";
// import { useTranslation } from "react-i18next";
// import { Parallax } from "rc-scroll-anim";
// import about from "../../assets/images/about.webp";
// import logo from "../../assets/images/logo.png";
// function AboutPage() {
//     const { t } = useTranslation();

import FooterNav from "../Other/FooterNav";
import HeroSection from "./HeroSection";

import MissionSection from "./MissionSection";
import Navbar from "./Navbar";
import Timeline from "./Timeline";
import WhoAreWe from "./WhoAreWe";
import "./about.css";
function AboutPage() {
  return (
    <div className="relative min-h-screen">
      <FooterNav />
      <Navbar />
      <HeroSection />
      <WhoAreWe />
      <MissionSection />
      <Timeline />
      {/* <LeadershipTeam />
      <InvestorsSection /> */}
    </div>
  );
}

export default AboutPage;
